import React from 'react';
import {Box, Tooltip} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

const EMPTY_DISPLAY = '—';

type EmptyDashProps = {
  title?: string;
};

export function EmptyDash({title = 'Data not available'}: EmptyDashProps) {
  const label = translate(title);

  return (
    <Tooltip title={label}>
      <Box component="span" aria-label={label}>
        <Body
          component="span"
          size="md"
          color={designSystemToken('semantic.fg.tertiary')}
        >
          {EMPTY_DISPLAY}
        </Body>
      </Box>
    </Tooltip>
  );
}

type EmptyMetricProps = {
  value: number | null | undefined;
  format: (value: number | null | undefined) => string;
  title?: string;
};

function EmptyMetric({value, format, title}: EmptyMetricProps) {
  const formatted = format(value);
  if (formatted === EMPTY_DISPLAY) {
    return <EmptyDash title={title} />;
  }
  return formatted;
}

export default EmptyMetric;
